// Shared formatters used by the Economics page tabs.

export const formatUsd = (value: number | undefined | null) => {
  if (value == null || isNaN(value)) return '-';
  return '$' + value.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

export const pnlColor = (pnl: number | undefined | null) => {
  if (pnl == null) return 'inherit';
  if (pnl > 0) return '#4caf50';
  if (pnl < 0) return '#f44336';
  return 'inherit';
};
